import React, {useContext, FC} from "react"
import {CodeContext} from "@irati/deals/context"
import {ButtonLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {Col} from "react-bootstrap"
import {Voucher} from "@irati/deals/types"
import {DealExternalLinks} from "@irati/types"
import VisitSiteButton from "./VisitSiteButton"
import CopyButton from "./CopyButton"

interface Props {
  onCopy: () => void
  voucher: Voucher
  externalLinks?: DealExternalLinks
}

const TicketCodeCTA: FC<Props> = ({voucher, onCopy, externalLinks}) => {
  const context = useContext(CodeContext)

  if (!externalLinks?.web) {
    return (
      <Col xs={12} md={12}>
        <CopyButton voucher={voucher} onCopy={onCopy} />
      </Col>
    )
  }

  if (context.shouldAutoOpenLink) {
    return (
      <Col xs={12} md={voucher.url ? 6 : 12}>
        <VisitSiteButton voucher={voucher} onCopy={onCopy} externalLinks={externalLinks} />
      </Col>
    )
  }

  return (
    <ButtonLink primary full href={externalLinks.web} target="_blank">
      <FormattedMessage id="perks.components.tickets.ticket.visitSite" />
    </ButtonLink>
  )
}

export default TicketCodeCTA
